import { type ReactNode } from "react";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        borderRadius: 12,
        border: "1px dashed var(--hairline-strong)",
        padding: 32,
        textAlign: "center",
        color: "var(--ink-1)",
        background: "var(--surface)",
        fontFamily: "Inter Variable, Inter, system-ui, sans-serif",
      }}
    >
      {icon ? <div style={{ color: "var(--ink-3)" }}>{icon}</div> : null}
      <div>
        <p style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>{title}</p>
        {description ? (
          <p
            style={{
              margin: "4px 0 0",
              maxWidth: 420,
              fontSize: 13,
              color: "var(--ink-3)",
            }}
          >
            {description}
          </p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
